
const scriptId = 'cloudflare-turnstile-script';
let scriptPromise;

function loadTurnstile() {
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }

  if (scriptPromise) {
    return scriptPromise;
  }

  scriptPromise = new Promise((resolve, reject) => {
    const existingScript = document.getElementById(scriptId);
    const script = existingScript || document.createElement('script');

    script.addEventListener('load', () => resolve(window.turnstile), {once: true});
    script.addEventListener('error', () => {
      script.remove();
      scriptPromise = null;
      reject(new Error('Could not load Turnstile.'));
    }, {once: true});

    if (!existingScript) {
      script.id = scriptId;
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  });

  return scriptPromise;
}

export default {
  props: {
    siteKey: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    hasError: false,
    widgetId: null,
  }),
  async mounted() {
    try {
      const turnstile = await loadTurnstile();

      if (!this.$refs.widget) {
        return;
      }

      this.widgetId = turnstile.render(this.$refs.widget, {
        sitekey: this.siteKey,
        action: 'form_submit',
        callback: token => this.$emit('input', token),
        'expired-callback': () => this.$emit('input', null),
        'error-callback': () => {
          this.hasError = true;
          this.$emit('input', null);
        },
      });
    } catch (error) {
      this.hasError = true;
      this.$emit('input', null);
    }
  },
  beforeDestroy() {
    if (this.widgetId !== null && window.turnstile) {
      window.turnstile.remove(this.widgetId);
    }
  },
  methods: {
    reset() {
      this.hasError = false;
      this.$emit('input', null);

      if (this.widgetId !== null && window.turnstile) {
        window.turnstile.reset(this.widgetId);
      }
    },
  },
};
